import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';

@Component({
  selector: 'lum-picklist-add-order-form',
  templateUrl: './picklist-add-order-form.component.html',
  styleUrls: ['./picklist-add-order-form.component.scss'],
})
export class PicklistAddOrderFormComponent implements OnInit {
  orders :number[] = [];
  constructor(
    public dialogRef :MatDialogRef<PicklistAddOrderFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data :{ title :string; message :string },
  ) {}

  ngOnInit() :void {}

  onSelectTags({ order } :{ order :number[] }) :void {
    this.orders = order;
  }

  onSubmitForm() :void {
    this.dialogRef.close(this.orders);
  }
}
